
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/homeowners",
      function () {
        return require("private-next-pages/homeowners/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/homeowners"])
      });
    }
  